import { useTranslation } from "react-i18next";
import { Link, Typography } from "@material-ui/core";
import { supportLinkWithProtocol } from "../../models/common/modules";
import { supportColor } from "../../hooks/use-map-theme-styles";
import LyfeTooltip from "../LyfeTooltip";

export const FeatureEncapsulationIcon: React.FC<{ toolTipText: string; wrapStyles?: any }> = ({ toolTipText, wrapStyles }) => {
	const { t } = useTranslation();
	const supportEmail = "support@lyfegen.com";

	return (
		<LyfeTooltip
			placement="right-start"
			interactive
			title={
				<Typography variant="body1">
					{t(toolTipText)}
					<Link style={{ color: supportColor, cursor: "pointer" }} href={supportLinkWithProtocol}>
						{supportEmail}
					</Link>
				</Typography>
			}
		>
			<span style={{ ...wrapStyles, cursor: "pointer" }}>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="12" cy="12" r="10" fill="#e3b340" />
					<path
						d="M11.333 13.954a.5.5 0 0 0-.5-.5H8.804a.5.5 0 0 1-.448-.72l3.362-6.813c.235-.474.949-.307.949.222v3.903a.5.5 0 0 0 .5.5h2.029a.5.5 0 0 1 .448.72l-3.362 6.813c-.235.474-.949.307-.949-.222v-3.902z"
						fill="#fff"
					/>
				</svg>
			</span>
		</LyfeTooltip>
	);
};
